import React from 'react';
import { Box, Modal, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { FlexColumn, FlexRow, ModalContentWrapper, PrimaryActionButton, SecondaryActionButton, StyledBox } from './styled';

export default function DeleteMfaModal({
  open, onClose, onConfirm, mfaName,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(30, 33, 41, 0.8675)',
          },
        },
      }}
    >
      <ModalContentWrapper type='warning'>
        <StyledBox>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <WarningAmberOutlinedIcon sx={{ fontSize: 80, color: 'warning.main' }} />
          </Box>
          <FlexColumn sx={{ gap: 2, alignItems: 'center', mt: 3 }}>
            <Typography id="modal-modal-title" variant="h4" component="h2">
              Remove {mfaName}?
            </Typography>
            <div style={{ textAlign: 'center' }}>
              <Typography id="modal-modal-title-1" variant="body1" component="h2">
                Are you sure you want to remove the {mfaName} authenticator?
              </Typography>
              <Typography id="modal-modal-description" variant="body1" component="h2">
                This cannot be undone.
              </Typography>
            </div>
          </FlexColumn>
          <FlexRow sx={{ justifyContent: 'flex-end', gap: 2, mt: 3 }}>
            <SecondaryActionButton
              variant="text"
              onClick={onClose}
            >
              No, Cancel
            </SecondaryActionButton>
            <PrimaryActionButton
              variant="outlined"
              onClick={onConfirm}
            >
              Yes, Remove
            </PrimaryActionButton>
          </FlexRow>
        </StyledBox>
      </ModalContentWrapper>
    </Modal>
  );
}
